<template>
  <div class="book">
    <Loader v-if="loading" />
    <div v-if="success" class="flex flex-col items-center mt-2">
      <i class="fas fa-check text-5xl text-green-400"></i>

      <div class="my-4 text-xl">
        {{ isManual ? 'Réservation ajoutée!' : 'Merci pour votre demande!' }}
      </div>

      <router-link
        v-if="isManual"
        to="admin"
        class="inline-block rounded px-2 py-1 font-bold text-white mt-2 bg-blue-300 hover:bg-blue-400"
      >
        Retour au calendrier
      </router-link>

      <!-- <button
        @click="resetForm()"
        class="inline-block flex rounded p-4 px-5 font-bold text-xl text-white mt-2"
        :class="{ 'bg-gray-300': !canRequest, 'bg-green-300 hover:bg-green-400': canRequest }"
      >
        Demander une autre réservation
      </button> -->
    </div>

    <form v-if="!success" @submit.prevent="requestBooking" class="flex flex-col text-left">
      <label class="text-l font-medium">Dates *</label>

      <div class="flex flex-row items-center">
        <DatePicker
          v-model="range"
          is-range
          :update-on-input="false"
          :disabled-dates="disabledDates"
          locale="fr"
          :model-config="{
            start: {
              timeAdjust: '14:00:00',
            },
            end: {
              timeAdjust: '12:00:00',
            },
          }"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <div class="flex items-center">
              <input
                :value="inputValue.start"
                v-on="inputEvents.start"
                class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
              />
              <svg class="w-3 h-3 mx-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
              <input
                :value="inputValue.end"
                v-on="inputEvents.end"
                class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
              />
            </div>
          </template>
        </DatePicker>

        <button v-if="range && range.start && range.end" @click.prevent="clearDate()">
          <i class="fas fa-trash text-sm text-gray-300 ml-2"></i>
        </button>
      </div>

      <div v-if="!duration && range && range.start && range.end" class="text-red-400">
        {{
          $route.params.id === 'trebeurden'
            ? 'Merci de choisir au moins une semaine de samedi à samedi.'
            : 'Merci de choisir deux dates et au moins une nuit.'
        }}
      </div>

      <label class="text-l font-medium  mt-4">Nom complet *</label>
      <input type="text" v-model="name" required class="border rounded p-1 mb-4" />

      <label class="text-l font-medium">Email {{ !isManual ? '*' : '' }}</label>
      <input type="email" v-model="email" :required="!isManual" class="border rounded p-1 mb-4" />

      <label class="text-l font-medium">Téléphone</label>
      <input type="phone" v-model="phone" class="border rounded p-1 mb-4" />

      <label class="text-l font-medium">Message</label>
      <textarea type="comment" v-model="comment" class="border rounded p-1 mb-4" />

      <div
        v-if="!isManual"
        class="g-recaptcha"
        data-sitekey="6Lfy1J4aAAAAACVnChytRZxCrsQX6pzRv1JGH9r9"
      ></div>

      <div class="flex flex-row items-bottom justify-between mt-2">
        <div class="flex-row flex items-center">
          <button
            type="submit"
            :disabled="!canRequest"
            class="inline-block flex rounded p-4 px-5 font-bold text-xl text-white"
            :class="{ 'bg-gray-300': !canRequest, 'bg-green-300 hover:bg-green-400': canRequest }"
          >
            {{ isManual ? 'Ajouter la réservation' : 'Envoyer ma demande' }}
          </button>

          <Loader v-if="booking" class="ml-3 mt-2" />
          <div v-if="error" class="ml-3 mt-2">Un erreur s'est produite.</div>
        </div>

        <!-- <div class="text-right" v-if="duration >= 1">
          <div class="text-xl font-bold">
            {{ duration }} nuit{{ duration > 1 ? 's' : '' }} x {{ pricePerNight }}€
          </div>
          <div class="text-4xl font-bold text-green-400">{{ totalPrice }}€</div>
          <div class="text-xs">*estimation</div>
        </div> -->
      </div>
    </form>
  </div>
</template>

<script>
import Loader from '../components/Loader.vue';
import * as api from '../api';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';

export default {
  name: 'Book',

  components: {
    Loader,
    DatePicker,
  },

  data() {
    return {
      loading: false,
      booking: false,
      success: false,
      error: false,

      name: '',
      email: '',
      phone: '',
      comment: '',
      range: { start: null, end: null },

      bookings: [],

      // IMPROVEMENT:
      // Spa: 160 eur / nuit
      // Thu, Aug 26, 2021 – Sun, Aug 29, 2021
      // 24h: 160 eur / nuit
      // 29 July 2021 - 1 August 2021
      // Carnaval: 100 eur / nuit
      // 15 février 2021 au vendredi 19 février 2021
      // pricePerNight: 80,
      cleaningPrice: 50,
    };
  },

  mounted() {
    this.fetchData();

    if (this.isWeekly) {
      document.querySelector('body').classList = 'isWeekly';
    }
  },

  watch: {
    $route(to, from) {
      this.fetchData();
    },
  },

  computed: {
    isManual() {
      return this.$route.name === 'add';
    },

    isWeekly() {
      return this.$route.params.id === 'trebeurden';
    },

    disabledDates() {
      let dates = this.bookings.map(booking => {
        let from = new Date(booking.from);
        let to = new Date(booking.to);

        if (to.getDate() - from.getDate() === 1) {
          // If one night stay
          return {
            start: from,
            end: to,
          };
        } else {
          from.setDate(from.getDate() + 1);
          to.setDate(to.getDate() - 1);

          from = from.toISOString();
          to = to.toISOString();

          return {
            start: from,
            end: to,
          };
        }
      });

      // dates.push({weekdays: [1, 2, 3, 4, 5, 6]})

      return dates;
    },

    duration() {
      if (!this.range) {
        return 0;
      }
      var a = new Date(this.range.start);
      var b = new Date(this.range.end);
      return Math.round((b - a) / 3600 / 24 / 1000);
    },

    pricePerNight() {
      if (this.duration >= 7) {
        return 75;
      } else {
        return 80;
      }
    },

    totalPrice() {
      return this.duration * this.pricePerNight + this.cleaningPrice;
    },

    canRequest() {
      return (
        !!this.name &&
        (!!this.email || this.isManual) &&
        !!this.range &&
        this.duration >= 1 &&
        !this.booking
      );
    },
  },

  methods: {
    async fetchData() {
      this.loading = true;
      this.bookings = await api.fetchBookings({ venue: this.$route.params.id });
      this.loading = false;
    },

    clearDate() {
      this.range = { start: null, end: null };
    },

    async requestBooking(e) {
      this.error = false;
      this.booking = true;

      const data = {
        from: this.range.start,
        to: this.range.end,
        name: this.name,
        email: this.email,
        phone: this.phone,
        comment: this.comment,
        venue: this.$route.params.id,
        price: this.totalPrice,
        recaptcha: !this.isManual && grecaptcha.getResponse(),
        manual: this.isManual,
      };

      try {
        const booking = await api.requestBooking({ data });
        this.success = true;
      } catch (err) {
        console.error(err);
        this.error = true;
      }

      this.booking = false;
    },

    resetForm() {
      this.name = '';
      this.email = '';
      this.phone = '';
      this.comment = '';
      this.range = null;
      this.success = false;

      this.fetchData();
    },
  },
};
</script>

<style lang="scss">
.isWeekly {
  .weekday-0,
  .weekday-1,
  .weekday-2,
  .weekday-3,
  .weekday-4,
  .weekday-5,
  .weekday-6 {
    pointer-events: none;
    touch-action: none;
    color: gray;
    opacity: 0.5;
  }
  .flatpickr-day:not(.flatpickr-disabled) {
    pointer-events: none;
    touch-action: none;
  }
  .flatpickr-day:nth-child(6):not(.flatpickr-disabled),
  .flatpickr-day:nth-child(13):not(.flatpickr-disabled),
  .flatpickr-day:nth-child(20):not(.flatpickr-disabled),
  .flatpickr-day:nth-child(27):not(.flatpickr-disabled),
  .flatpickr-day:nth-child(34):not(.flatpickr-disabled) {
    pointer-events: all !important;
    touch-action: auto !important;
    color: rgb(40, 224, 40) !important;
    color: gray;
    font-weight: bold;
  }
  // .flatpickr-day.flatpickr-disabled {
  //   color: red !important;
  // }
}
.prevMonthDay,
.nextMonthDay {
  opacity: 0;
  pointer-events: none;
  touch-action: none;
}
</style>
